var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.272 49.858l10.87 10.87c5.183-3.327 38.931-25.923 39.839-50.709-24.786.908-47.382 34.656-50.709 39.839zM30 63a.999.999 0 01-.707-.293l-12-12a1 1 0 01-.147-1.228C18.179 47.786 42.763 8 71 8a1 1 0 011 1c0 28.237-39.786 52.821-41.479 53.854A1.005 1.005 0 0130 63z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 64a.997.997 0 01-.707-.293l-8-8a.999.999 0 010-1.414l3-3 1.414 1.414L18.414 55 25 61.586l2.293-2.293 1.414 1.414-3 3A.997.997 0 0125 64",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 72a1 1 0 01-1-1c0-.303.071-7.485 6.293-13.707l1.414 1.414c-4.251 4.251-5.336 9.078-5.613 11.199 2.119-.276 6.947-1.361 11.199-5.613l1.414 1.414C16.486 71.929 9.303 72 9 72",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 23c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 8c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zM45 32c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 8c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zM36 41c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 8c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zM45 72H35a1 1 0 01-1-1v-8h2v7h8.352l16.735-37.408 1.826.816-17 38A.998.998 0 0145 72M17 46H9a1 1 0 01-1-1V35a1 1 0 01.592-.913l38-17 .816 1.826L10 35.648V44h7v2M69 20c-4.962 0-9-4.037-9-9h2c0 3.859 3.14 7 7 7v2",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationRocket;